import apiClient from './client'

export const questionsApi = {
  askQuestion: async (data) => {
    const response = await apiClient.post('/questions', data)
    return response.data
  },

  postAnswer: async (data) => {
    const response = await apiClient.post('/answers', data)
    return response.data
  },

  getCourseQuestions: async (courseId) => {
    const response = await apiClient.get(`/courses/${courseId}/questions`)
    return response.data
  },

  getLectureQuestions: async (lectureId) => {
    const response = await apiClient.get(`/lectures/${lectureId}/questions`)
    return response.data
  },
}

